import React from "react";

function SvgIcMapPoi122(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M17.012 10.78a.118.118 0 01.006.02.985.985 0 01.982.808l-.017 5.423c-.018.542-.45.88-.994.976l-.029.009 1.723 7.64a.998.998 0 01-.514 1.316.998.998 0 01-1.317-.514l-1.787-7.922c-.013 0-.026-.002-.04-.001l-.023 7.425a1.033 1.033 0 01-2.065 0l.024-8.552c-.002-.026-.016-.048-.016-.074V14.37L10 15.415v11.092a.5.5 0 11-1 0V15.402a.987.987 0 01-.46-.53 1 1 0 01.609-1.277l4.74-2.387c.834-.42 1.822-.427 2.228-.427zM20.5 9.763c.825 0 1.5 1.35 1.5 3v1.996c0 1.65-.675 3-1.5 3s-1.5-1.35-1.5-3v-1.996c0-1.65.675-3 1.5-3zM15.945 6a2 2 0 11.001 4 2 2 0 010-4z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi122;
